import { render, staticRenderFns } from "./RoomCategory.vue?vue&type=template&id=3fdc16e5&scoped=true&"
import script from "./RoomCategory.vue?vue&type=script&lang=js&"
export * from "./RoomCategory.vue?vue&type=script&lang=js&"
import style0 from "./RoomCategory.vue?vue&type=style&index=0&id=3fdc16e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc16e5",
  null
  
)

export default component.exports